<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div class="html-snackbar-container" [ngClass]="snackData.action.useCloseButton ? 'with-button' : ''">
    <div class='snackbar-header mat-{{snackData.action.color}}' *ngIf='snackData.action?.label'>{{snackData.action.label}}</div>
    <div class='snackbar-content'>
        <span [innerHTML]="snackData.message"></span>
        <button mat-icon-button
                *ngIf="snackData.action.useCloseButton"
                (click)="close()">
            <mat-icon svgIcon='cancel-circle' [color]='snackData.action.color' aria-label='Close'></mat-icon>
        </button>
    </div>
</div>
